<template>
  <div class="tab-content">
    <!-- 基本信息内容 -->
    <div class="basic-info-section">

      <!-- 测试车辆区域 -->
      <div class="info-area">
        <div class="vehicle-wrapper">
          <h3 class="vehicle">低速无人驾驶车辆（装备）信息</h3>
        </div>
        <div class="vehicle-detail-container">
          <div class="vehicle-edit-section">
            <div class="vehicle-edit-row">
              <div class="vehicle-detail-item">
                <span class="vehicle-detail-label">车辆识别代号(VIN)：</span>
                <span class="vehicle-detail-value">{{ vehicle.vin || '-' }}</span>
              </div>
              <div class="vehicle-detail-item">
                <span class="vehicle-detail-label">车辆型号：</span>
                <span class="vehicle-detail-value">{{ vehicle.model || '-' }}</span>
              </div>
            </div>
            <div class="vehicle-edit-row">
              <div class="vehicle-detail-item">
                <span class="vehicle-detail-label">类型：</span>
                <span class="vehicle-detail-value">
                  {{ vehicle.type ? props.vehicleTypeList.find(item => item.id === vehicle.type)?.name : '-' }}
                </span>
              </div>
              <div class="vehicle-detail-item">
                <span class="vehicle-detail-label">颜色：</span>
                <span class="vehicle-detail-value">{{ vehicle.color || '-' }}</span>
              </div>
            </div>
            <div class="vehicle-edit-row">
              <div class="vehicle-detail-item">
                <span class="vehicle-detail-label">生产企业：</span>
                <span class="vehicle-detail-value">{{ vehicle.manufacturer || '-' }}</span>
              </div>
              <div class="vehicle-detail-item">
                <span class="vehicle-detail-label">生产日期：</span>
                <span class="vehicle-detail-value">{{ vehicle.productionDate || '-' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup name="BasicInfoTab">
import { defineProps, ref, onMounted } from 'vue';
import { getApplicationVehicleByApplicationId } from "@/api/application/applicationVehicles";

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  vehicleTypeList: {
    type: Array,
    default: () => ([])
  },
});

// 测试车辆数据
const vehicle = ref({});

const getVehicle = async () => {
  getApplicationVehicleByApplicationId(props.id).then((res) => {
    vehicle.value = res.data;
  });
}

// 组件挂载时获取数据
onMounted(async () => {
  try {
    await getVehicle(props.id);
  } catch (error) {
    console.error('获取申请无人驾驶车辆信息失败:', error);
  }
});
</script>

<style scoped>
.tab-content {
  background: #fff;
  margin-bottom: 80px;
}

.basic-info-section {
  background: #fff;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 4px;
}

.info-area {
  margin-bottom: 10px;
  padding: 20px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  background-color: #ffffff;
}

.vehicle-wrapper {
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #d9d9d9;
}

.vehicle {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.vehicle-detail-container {
  display: flex;
  justify-content: center;
}

.vehicle-edit-section {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
  width: 100%;
  max-width: 800px;
}

.vehicle-edit-row {
  display: flex;
  margin-bottom: 16px;
  gap: 16px;
  justify-content: space-between;
}

.vehicle-detail-item {
  display: flex;
  align-items: center;
  width: 380px;
}

.vehicle-detail-label {
  font-weight: 500;
  color: #666;
  min-width: 130px;
  text-align: right;
  margin-right: 10px;
  flex-shrink: 0;
}

.vehicle-detail-value {
  color: #333;
  text-align: left;
  flex: 1;
}
</style>